/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Radio as AntRadio } from 'antd';
import clsx from 'clsx';

import { GRADIENTS } from '@constants';

import s from './styles.module.less';

const setColor = ({ colour, style }) => ({
  '--radio-color': `${colour}`,
  ...style,
});

const ColorPickerButton = ({ className, color, style, ...props }) => {
  const colour = GRADIENTS[color]?.value || color;
  return <AntRadio style={setColor({ colour, style })} className={clsx(className, s.customRadioButton)} {...props} />;
};

AntRadio.ColorPickerButton = ColorPickerButton;

export default AntRadio;
